import Popup from "./popup";

class PopupRegisterAccountLogin extends Popup {

  public popupRegisterAccount: HTMLElement;
  public hasShown: String | null;

  private showPopup() {
    super.onTrigger({target: 'login-popup-register', size: 'large--py-0'});
    localStorage.setItem('register-popup-login-shown', '1');
  }

  bindings() {
    super.bindings();
    if(this.popupRegisterAccount && !this.hasShown && ['/login', '/ch/login', '/en/login'].includes(document.location.pathname) && !document.body.classList.contains('is-user')) {
      setTimeout( () => this.showPopup(), 2000);
    }
  }

  cache() {
    super.cache();
    this.popupRegisterAccount = document.querySelector('.js-o-popup__register-account-login') as HTMLElement;
    this.hasShown = localStorage.getItem('register-popup-login-shown');
  }

  init() {
    this.selectorClass = 'register-popup';
    this.cache();
    this.bindings();
  }
}

export default PopupRegisterAccountLogin;
